import { Bounce } from "react-toastify";

export const userRoleType = {
  student: "student",
  admin: "admin",
};

export const status = {
  approved: "approved",
  rejected: "rejected",
  pending: "pending",
};

export const toastTypesKeys = {
  success: "success",
  error: "error",
};

export const toastKeys: any = {
  position: "top-center",
  autoClose: 2500,
  hideProgressBar: false,
  closeOnClick: false,
  closeButton: false,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  progress: undefined,
  theme: "light",
  transition: Bounce,
};

export const statusCode = {
  approved: 1,
  rejected: 2,
};

export const baseURL = "https://niyel-tracker-api.aristarc-conseils.com";

export const moduleKeys = {
  people: "people",
  practice: "practice",
  policy: "policy",
};
